import {api} from './api'
import {ApiResponse, Wallet} from '../types'

export const getWallets = async (): Promise<Wallet> => {
    try {
        const response = await api.get<ApiResponse<Wallet>>('/api/admin/wallets')
        console.log('💰 Wallets Response:', response.data)
        return response.data.data || {alfa: 0, touch: 0}
    } catch (error) {
        console.error('Error fetching wallets:', error)
        return {alfa: 0, touch: 0}
    }
}

export const updateWalletBalance = async (walletType: 'alfa' | 'touch', amount: number): Promise<boolean> => {
    try {
        const response = await api.post('/api/admin/wallets/update', {walletType, amount})
        return response.data.success
    } catch (error) {
        console.error('Error updating wallet:', error)
        return false
    }
}